module.exports = __webpack_public_path__ + "static/media/gts07.9cd11196.png";